import { BellRing, CalendarClock, FileSignature, Send, UserCheck, Video } from "lucide-react";

/**
 * Catalog of hot-lead actions shared by the questions list and the
 * lead-destination screen (kept in its own module to avoid an import cycle
 * between questions.jsx and the custom step components).
 */
export const HOT_ACTIONS = [
  {
    id: "close_contract",
    label: "Fechar a venda e gerar contrato",
    desc: "A IA conduz o fechamento e envia o contrato para assinatura digital.",
    icon: FileSignature,
  },
  {
    id: "transfer_human",
    label: "Transferir para um humano",
    desc: "O lead vai direto para quem você escolher.",
    icon: UserCheck,
  },
  {
    id: "send_crm",
    label: "Cadastrar no CRM",
    desc: "Entra no seu funil para o time comercial.",
    icon: Send,
  },
  {
    id: "register_notify",
    label: "Registrar e avisar",
    desc: "Salva o atendimento e notifica o responsável.",
    icon: BellRing,
  },
  {
    id: "schedule_callback",
    label: "Agendar retorno",
    desc: "Cria um retorno na agenda Google da equipe (configurada no Kickoff).",
    icon: CalendarClock,
  },
  {
    id: "schedule_meeting",
    label: "Agendar reunião",
    desc: "Cria uma reunião com link do Meet na agenda da equipe (configurada no Kickoff).",
    icon: Video,
  },
];

/** What each action needs — drives which follow-up questions are shown. */
export const ACTION_META = {
  // The AI closes the deal and sends the contract for signature (ZapSign,
  // configured in the signature-tool question) — no recipient/hours to collect.
  close_contract: { recipient: "none", hours: false },
  transfer_human: {
    recipient: "required",
    recipientLabel: "Transferir para",
    recipientTitle: "Quem recebe o lead quente?",
    hours: true,
  },
  register_notify: {
    recipient: "required",
    recipientLabel: "Avisar",
    recipientTitle: "Quem deve ser avisado?",
    hours: true,
  },
  send_crm: {
    recipient: "optional",
    recipientLabel: "Responsável no CRM (opcional)",
    recipientTitle: "Quem acompanha o lead no CRM?",
    hours: false,
    note: "O lead entra automaticamente no seu CRM — o time comercial assume daí.",
  },
  schedule_callback: { recipient: "none", hours: false },
  schedule_meeting: { recipient: "none", hours: false },
};
